"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrongBrowserAlert = void 0;
var _react = _interopRequireDefault(require("react"));
var _components = require("../../../components");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WrongBrowserAlert = function WrongBrowserAlert(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('text-alertred-60 bg-alertred-10 tw-body-sm-regular px-[10px] py-[6px] relative flex gap-x-[8px] rounded-[6px]', className)
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    className: "flex-shrink-0",
    type: "alert",
    size: 20
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, "Incompatible browser."), " To join the call, use another browser (e.g. Safari if on iOS).", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://api.support.vonage.com/hc/en-us/articles/6646229178780-What-browser-versions-are-compatible-with-the-Vonage-Video-API-",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "More info")));
};
exports.WrongBrowserAlert = WrongBrowserAlert;